var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('vue-json-pretty',{attrs:{"data":_vm.item.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }